export default {"src":"/_next/static/media/bi_stars.e4bc4c75.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};